<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 설비종류 -->
          <c-select
            type="search"
            :comboItems="typeItems"
            itemText="codeName"
            itemValue="code"
            name="machineryTypeCd"
            label="유형"
            v-model="searchParam.machineryTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            label="점검기간"
            defaultStart="-6M"
            defaultEnd="6M"
            name="period"
            :isToyear="true"
            v-model="period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 진행단계 -->
          <c-select
            :comboItems="statusItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="completeFlag"
            label="진행단계"
            v-model="searchParam.completeFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="중점점검 결과 목록"
      :columns="grid.columns"
      :data="grid.data"
      rowKey="focusInspectionId"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <div>
          <q-btn-group outline>
            <!-- <c-btn label="검사결과 일괄 업로드" :editable="editable" icon="assignment" /> -->
            <c-btn label="등록" v-if="editable" :editable="editable" icon="add" @btnClicked="onItemClick" />
            <c-btn label="검색" icon="search" @btnClicked="getList" />
          </q-btn-group>
        </div>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: "hazard-focus-inspection",
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          mainPeriod: [],
          mainPlantCd: null,
        }
      },
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "사업장",
            style: 'width:100px', 
            align: "center",
            sortable: true,
          },
          {
            name: "machineryTypeName",
            field: "machineryTypeName",
            label: "기계유형",
            style: 'width:100px', 
            align: "center",
            sortable: true,
          },
          {
            name: "focusName",
            field: "focusName",
            label: "점검명",
            style: 'width:300px', 
            align: "left",
            sortable: true,
            type: "link",
          },
          {
            name: "inspectionDate",
            field: "inspectionDate",
            label: "점검일",
            style: 'width:120px', 
            align: "center",
            sortable: true,
          },
          {
            name: "inspectionUserName",
            field: "inspectionUserName",
            label: "점검자",
            style: 'width:100px', 
            align: "center",
            sortable: true,
          },
          {
            name: "completeFlagName",
            field: "completeFlagName",
            label: "완료여부",
            style: 'width:120px', 
            align: "center",
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        startYmd: '',
        endYmd: '',
        completeFlag: null,
        machineryTypeCd: null,
      },
      period: [],
      typeItems: [],
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      statusItems: [
        { code: "N", codeName: "점검중" },
        { code: "Y", codeName: "점검완료" },
      ],
      isResult: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      // url setting
      this.editable = this.$route.meta.editable;
      // 메인에서 호출한 팝업파라미터
      if (this.popupParam.mainPeriod.length > 0  || this.popupParam.mainPlantCd) {
        this.searchParam.plantCd = (!this.popupParam.mainPlantCd || this.popupParam.mainPlantCd.length > 3 ? null : this.popupParam.mainPlantCd);
        this.period = this.popupParam.mainPeriod;
      }
      this.listUrl = selectConfig.sop.hhm.hazard.focus.info.list.url;
      // list setting
      this.getTypeDetail();
      this.getList();
    },
    getList() {
      if (this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }
      // 전체조회
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    getTypeDetail() {
      this.$http.url = this.$format(selectConfig.sys.code.mst.list.attr.url, 'HHM_TYPE_CD', 'N');
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.typeItems = _result.data;
      },
      () => {
      });
    },
    /* eslint-disable no-unused-vars */ 
    linkClick(row, col, index) {
      this.popupOptions.title = "중점점검 결과 상세"; // 중점점검 결과 상세
      this.popupOptions.param = {
        focusInspectionId: row ? row.focusInspectionId : '',
      };
      this.popupOptions.target = () =>
        import(`${"./hazardFocusInspectionDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.height = '300px';
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    onItemClick() {
      this.linkClick(null)
    },
  },
};
</script>